module.exports = __webpack_public_path__ + "img/dstv-smartcard-2.c08c4f3e.jpg";